@if (showEditionControls() || showValidity()) {
  <div class="course-edition" role="group" [attr.aria-label]="'COURSE.EDITION.SECTION_LABEL' | translate">
    @if (showEditionControls()) {
      <div class="course-edition__switch">
        <app-enfaf-switch-dark
          data-testid="isSuccessor"
          color="light"
          [control]="isSuccessorControl()"
          [disabled]="true"
          [label]="'COURSE.EDITION.IS_SUCCESSOR' | translate"
        />
        <app-enfaf-icon
          role="img"
          tabindex="0"
          [attr.aria-label]="(editMode() ? 'COURSE.EDITION.IS_SUCCESSOR_TOOLTIP_EDIT' : 'COURSE.EDITION.IS_SUCCESSOR_TOOLTIP_CREATE') | translate"
          [matTooltip]="(editMode() ? 'COURSE.EDITION.IS_SUCCESSOR_TOOLTIP_EDIT' : 'COURSE.EDITION.IS_SUCCESSOR_TOOLTIP_CREATE') | translate"
          matTooltipClass="chekbox-group-tooltip"
          matTooltipPosition="above"
          svgIconName="info-dark"
          iconSize="24px"
        ></app-enfaf-icon>
      </div>

      <enfaf-input
        data-testid="predecessor"
        color="light"
        name="predecessorRootName"
        autocomplete="off"
        [readonly]="true"
        [control]="rootNameControl"
        [label]="'COURSE.EDITION.PREDECESSOR_LABEL' | translate"
        [description]="'COURSE.EDITION.ROOT_LOCKED_HINT' | translate"
      ></enfaf-input>

      @if (isLoadingPrefill()) {
        <span class="course-edition__loading" aria-live="polite">{{ 'COURSE.EDITION.LOADING_SOURCE' | translate }}</span>
      }

      <enfaf-input
        data-testid="editionNumber"
        [appFieldErrorA11y]="showsError(editionNumberControl(), editionNumberError)"
        color="light"
        type="number"
        name="editionNumber"
        autocomplete="off"
        [control]="editionNumberControl()"
        [label]="'COURSE.EDITION.EDITION_NUMBER' | translate"
        [placeholder]="'COURSE.EDITION.EDITION_NUMBER' | translate"
        [description]="'COURSE.EDITION.EDITION_NUMBER_HINT' | translate"
        [min]="minEditionNumber"
        [max]="maxEditionNumber"
        [step]="1"
        [errorLabel]="editionNumberError"
      ></enfaf-input>
    }

    @if (showValidity()) {
      <div class="course-edition__validity">
        <enfaf-datetime-picker-light
          data-testid="validFrom"
          variant="light"
          [appFieldErrorA11y]="showsError(validFromControl(), validFromError)"
          [manualInputParser]="parseValidityText"
          name="purchaseValidFrom"
          [control]="$any(validFromControl())"
          [minDate]="validityMinDate"
          [maxDate]="validityMaxDate"
          [label]="'COURSE.EDITION.VALID_FROM' | translate"
          placeholder=""
          [errorLabel]="validFromError"
        />
        <enfaf-datetime-picker-light
          data-testid="validUntil"
          variant="light"
          [appFieldErrorA11y]="showsError(validUntilControl(), validUntilError)"
          [manualInputParser]="parseValidityText"
          name="purchaseValidUntil"
          [control]="$any(validUntilControl())"
          [minDate]="validityMinDate"
          [maxDate]="validityMaxDate"
          [label]="'COURSE.EDITION.VALID_UNTIL' | translate"
          placeholder=""
          [errorLabel]="validUntilError"
        />
      </div>
      <span class="course-edition__note">{{ 'COURSE.EDITION.VALIDITY_HINT' | translate }}</span>
    }
  </div>
}
